module.exports = __webpack_public_path__ + "img/misson_vision_value_02_2.0d7f9019.jpg";